<template>
  <div class="oap-rating">
    <div class="oap-rating__list">
      <div class="oap-rating__stars">
        <template v-for="(_, i) in ratingMax">
          <div :class="['oap-rating__star', { 'oap-rating__star--filled': i < fullStarsAmount }]">
            <span
              v-if="hasRemainder && i == fullStarsAmount"
              class="oap-rating__star--filled-percentage"
              :style="`width: ${getVisuallyAdjustedRatingPercentage()};`"
            ></span>
          </div>
        </template>
      </div>
      <span
        class="oap-rating__average"
        :class="{ '-mobile-visible': displayReviewCount }"
        :style="`color: {{textColor}};`"
      >
        {{ rating }}/{{ ratingMax }}<span v-if="ratingCountText">&nbsp;{{ ratingCountText }}</span>
      </span>
      <span class="is-sr-only">
        {{ srText }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  rating: {
    type: Number,
    default: 0,
  },

  ratingMax: {
    type: Number,
    default: 5,
  },

  textColor: {
    type: [String, null],
    default: null,
  },

  srText: {
    type: String,
    default: '',
  },

  displayReviewCount: {
    type: Boolean,
    default: false,
  },

  ratingCountText: {
    type: String,
    default: '',
  },
});

const fullStarsAmount = computed(() => Math.floor(props.rating));
const hasRemainder = computed(() => Math.round((props.rating % 1) * 10));

function getVisuallyAdjustedRatingPercentage() {
  // Map decimal portions to visual adjustments
  // Key is decimal * 10 (e.g., 0.1 -> 1, 0.7 -> 7)
  const adjustmentMap = {
    1: 17, // 4.1, 3.1, etc.
    2: 15,
    3: 13,
    4: 7,
    7: -5,
    8: -3,
    9: -5,
  };

  // Extract decimal part and convert to threshold key
  const decimal = props.rating % 1;
  const ratingThreshold = Math.round(decimal * 10);

  // Get adjustment value (defaults to 0 if not found, like 5 and 6)
  const adjustment = adjustmentMap[ratingThreshold] ?? 0;
  const rawPercentage = ratingThreshold * 10;
  const adjustedPercentage = Math.min(100, rawPercentage + adjustment);

  return `${adjustedPercentage}%`;
}
</script>
